import { createStore, applyMiddleware } from 'redux';
import RootReducer from './reducers/RootReducers';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';
import { pick, throttle } from 'lodash';

const middlewares = [thunk];

// if (process.env.NODE_ENV !== 'production') {
//   middlewares.push(logger);
// }


const saveToLocalstorage = throttle((state) => {
  // Save tixwix state
  const tixwix = pick(state.tixwix, ['date', 'marketType', 'priceGoing', 'trading']);
  localStorage.setItem('tixwix', JSON.stringify(tixwix));

  // Save uiState
  const uiState = pick(state.UIState, ['assetType', 'muted']);
  localStorage.setItem('uiState', JSON.stringify(uiState));

  // Save uiState
  const contests = pick(state.contestSeries?.view, ['currentView', 'selectedCoins', 'selectedDurations']);
  localStorage.setItem('contestsState', JSON.stringify(contests));
}, 500);

const store = createStore(
  RootReducer,
  composeWithDevTools(applyMiddleware(...middlewares)),
);

store.subscribe(() => saveToLocalstorage(store.getState()));

export default store;
